<script setup>
import CHomeBanner from "@/Components/CHomeBanner.vue";
import CHomeCampaigns from "@/Components/CHomeCampaigns.vue";
import Testimonials from "@/Pages/Institutional/Components/Testimonials.vue";
import CHomeHighlights from "@/Components/CHomeHighlights.vue";
import {Head} from "@inertiajs/vue3";
import StoreFrontDefaultLayout from "@/Layouts/StoreFrontDefaultLayout.vue";
import {h} from "vue";

defineProps({
    banners: Object,
    campaigns: Object,
    highlightsProducts: Object,
    canViewPrices: Boolean,
    canViewStock: Boolean,
})

defineOptions({layout: h(StoreFrontDefaultLayout, {cart: true, bgColor: 'white', switchCategoryMenu: portalOptions.switchCategoryMenu})})

</script>

<template>
    <Head title="Brindes Corporativos" />
    <h1 style="width: 1px; height: 1px; position: absolute; color: #ffffff00">Creative Design</h1>
    <c-home-banner :banners="banners" class="pb-10"></c-home-banner>
    <c-home-campaigns :campaigns="campaigns"></c-home-campaigns>
    <c-home-highlights :highlights-products="highlightsProducts" :can-view-price="canViewPrices" :can-view-stock="canViewStock"></c-home-highlights>
    <testimonials></testimonials>
</template>

<style scoped>

</style>